module.exports = __webpack_public_path__ + "static/img/d1.1539bc4f.png";